/**
 * The practice's front-desk goal: the whole-percent target the Benefits
 * Capture page draws as its target line, one value per organization
 * (`organizations.frontDeskGoal`), set by VitalRev staff on the practice's
 * behalf. Absent, out of range or not a whole number → the product default,
 * so the page and the staff console never disagree on what a bad value means.
 */

/** The launch default — the prototype's placeholder, revisited after the
 *  validation run on an existing practice. */
export const DEFAULT_FRONT_DESK_GOAL = 75

export function isValidFrontDeskGoal(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= 100
}

/** The goal to draw: the stored value when it is a whole number from 1 to
 *  100, the default otherwise. */
export function resolveFrontDeskGoal(stored: unknown): number {
  return isValidFrontDeskGoal(stored) ? stored : DEFAULT_FRONT_DESK_GOAL
}
